export function downloadBlob(content, filename, type, open) {
    const blob = new Blob([content], { type });
    const URL = window.URL || window.webkitURL;
    // создаём object URL из Blob
    const downloadUrl = URL.createObjectURL(blob);
    if (open) {
        const newWin = window.open(downloadUrl, '_blank');
        if (newWin != null) {
            document.head.append(filename);
            newWin.focus();
            URL.revokeObjectURL(downloadUrl);
        }
    }
    else {
        const link = document.createElement('a');
        link.setAttribute('href', downloadUrl);
        link.setAttribute('download', filename);
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
